import { render } from "./DeleteResultsModal.vue?vue&type=template&id=0a319966&scoped=true&ts=true"
import script from "./DeleteResultsModal.vue?vue&type=script&lang=ts"
export * from "./DeleteResultsModal.vue?vue&type=script&lang=ts"

import "./DeleteResultsModal.vue?vue&type=style&index=0&id=0a319966&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a319966"]])

export default __exports__